import { db, firebase } from '@/plugins/firebase';

export async function setUserDoc(userId, payload) {
  const userDocRef = await db.collection('users').doc(userId);

  try {
    await userDocRef.set(
      {
        ...payload,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      },
      { merge: true }
    );
    const userDocSnapShot = await userDocRef.get();
    return userDocSnapShot.data();
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function updateUserDoc(userId, payload) {
  const userDocRef = await db.collection('users').doc(userId);

  try {
    await userDocRef.update({
      ...payload,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    });
    const userDocSnapShot = await userDocRef.get();
    return userDocSnapShot.data();
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function createUserDoc(userId, payload) {
  const userDocRef = await db.collection('users').doc(userId);

  try {
    await userDocRef.set(
      {
        ...payload,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      },
      { merge: true }
    );
    const userDocSnapShot = await userDocRef.get();
    return userDocSnapShot.data();
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function getUserDoc(userId) {
  const userDocQuerySnapShot = await db.collection('users').doc(userId).get();
  if (!userDocQuerySnapShot.exists) return null;
  const userDoc = userDocQuerySnapShot.data();
  return userDoc;
}

export function getUserDocRef(userId) {
  return db.collection('users').doc(userId);
}
